import styled from 'styled-components';

export const Section = styled.div`
  padding-left: 10px;
  border-left: 1px solid #e9edf0;
`;
